import React, { useState } from 'react'
import { FaLongArrowAltRight } from "react-icons/fa";
import { FaLongArrowAltLeft } from "react-icons/fa";
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { API } from '../../../Services/axios';
import { calculateTerraceQuantity, getTerraceArea } from '../../../Services/quoteCalculator';

// import { useState } from 'react';

import SendQuoteToCartButton from '../../../Components/SendQuoteToCart/SendQuoteToCartButton';
import { syncQuoteToEcommerceCart } from '../../../Services/quoteSyncToEcommerce';
import './TerraceProduct.css';


const TerraceProduct = ({ quoteData }) => {
  // Récupérer les produits sélectionnés depuis Redux
  const selectedProducts = useSelector(state => state.selectedProducts.selectedProducts);
  const selectedProject = useSelector(state => state.selectedProject.selectedProject);
  const sectionNames = useSelector(state => state.selectedProducts.sectionNames);
  const userInputs = useSelector(state => state.selectedProducts.userInputs);
  const surfaceArea = useSelector(state => state.selectedProducts.surfaceArea);

  // Calcul de surface pour TERASSE_EXTERIEUR
  const terraceArea = getTerraceArea(userInputs || {}, 'TERASSE_EXTERIEUR') || surfaceArea || 0;

  // Table de calculs demandée
  const terraceFormulaRows = [
    { 
      label: 'Lambourde', 
      code: 'LAMBOURDE', 
      formula: '1) ML total = m² terrasse × 2 | 2) Nombre de lambourdes = ML total ÷ 3 (arrondi sup.)', 
      unit: 'UN',
      showDetailedCalculation: true
    },
    { label: 'Bande bitumineuse', code: 'BANDE_BITUMINEUSE', formula: 'UN total = total ML de lambourde / 20 (arrondi sup.)', unit: 'UN' },
    { label: 'Cale ventilation', code: 'CALE_VENTILATION', formula: 'UN total = m² terrasse / 19 (arrondi sup.)', unit: 'UN' },
    { label: 'Visserie', code: 'VISERIE', formula: 'BT total = m² terrasse × 40 / 500 (arrondi sup.)', unit: 'BT' },
    { label: 'Plots Dakota', code: 'PLOTS_DAKOTA', formula: 'UN total = m² terrasse x 4', unit: 'UN' },
    { label: "Cale d'isolation", code: 'CALE_D_ISOLATION', formula: 'BT total = m² terrasse x 4 / 25 (arrondi sup.)', unit: 'BT' },
    { label: 'Géotextile', code: 'GEOTEXTILE', formula: 'UN total = m² terrasse / 25 (arrondi sup.)', unit: 'UN' },
    { label: 'Espaceurs / Kit serre lame', code: 'ESPACEUR_&_KIT_SERRE_LAME', formula: '1 UN', unit: 'UN' },
    { label: 'Foret pour pré perçage', code: 'FORET_POUR_PRE_PERCAGE', formula: 'UN total = m² terrasse / 70 (arrondi sup.)', unit: 'UN' },
    { label: 'Trait Découp', code: 'TRAIT_DECOUP', formula: '1 UN', unit: 'UN' },
    { label: 'Lames de terrasse (+7% chute)', code: 'LAMES_TERRASSE', formula: 'Nombre de lames = (surface ÷ 0,435) × 1,07 (arrondi sup.)', unit: 'UN' },
  ].map(row => ({
    ...row,
    quantity: terraceArea ? calculateTerraceQuantity(row.code, terraceArea) : 0
  }));
  
  // Debug: Afficher la structure des données
  console.log('🔍 TerraceProduct - quoteData:', quoteData);
  console.log('🔍 TerraceProduct - quoteData.items:', quoteData?.items);
  console.log('🔍 TerraceProduct - quoteData.total_cost:', quoteData?.total_cost);
  console.log('🔍 TerraceProduct - selectedProducts:', selectedProducts);
  console.log('🔍 TerraceProduct - selectedProducts.length:', selectedProducts?.length);
  
  if (quoteData?.items) {
    console.log('🔍 Premier item détaillé:', quoteData.items[0]);
    console.log('🔍 Toutes les clés du premier item:', Object.keys(quoteData.items[0] || {}));
  }
  
  // Fonction pour récupérer le nom d'une section
  const getSectionName = (sectionId) => {
    console.log('🔍 Recherche du nom de section pour ID:', sectionId);
    console.log('🔍 sectionNames sauvegardés:', sectionNames);
    
    // Essayer d'abord avec les noms sauvegardés
    if (sectionNames && sectionNames[sectionId]) {
      console.log('🔍 Nom trouvé dans sectionNames:', sectionNames[sectionId]);
      return sectionNames[sectionId];
    }
    
    // Essayer avec le projet sélectionné
    if (selectedProject && selectedProject.steps) {
      for (const step of selectedProject.steps) {
        if (step.sections) {
          for (const section of step.sections) {
            if (section.id === sectionId) {
              console.log('🔍 Section correspondante trouvée dans selectedProject:', section.name);
              return section.name || `Section ${sectionId}`;
            }
          }
        }
      }
    }
    
    // Fallback: essayer de deviner le nom basé sur l'ID ou utiliser un nom générique
    const sectionNameMap = {
      '58aa0e88-2e28-49ce-9e4e-4fc6a11c2547': 'Taille de votre terrasse',
      '56d97c9b-4161-4364-b7d0-74d2f5ec6d7f': 'VOTRE KIT TERRASSE RULLIER SUR MESURE',
      'surface': 'Surface',
      'dimension': 'Dimensions',
      'input': 'Information'
    };
    
    if (sectionNameMap[sectionId]) {
      console.log('🔍 Nom trouvé dans sectionNameMap:', sectionNameMap[sectionId]);
      return sectionNameMap[sectionId];
    }
    
    console.log('🔍 Aucun nom trouvé, utilisation de l\'ID:', sectionId);
    return `Section ${sectionId}`;
  };

  const [syncStatus, setSyncStatus] = useState(null);
  const [syncMessage, setSyncMessage] = useState(null);
  const [syncErrors, setSyncErrors] = useState([]);

  // Fonction pour récupérer les détails du produit
  const getProductDetails = (item) => {
    const sku = item.sku || item.product_sku || '';
    // Si c'est un selectedProduct, utiliser directement ses propriétés
    if (item.name && item.price !== undefined) {
      return {
        name: item.name,
        image: item.image || "/assets/images/lalliard-lame-terrasse-focus_pin_du_nord_marron.png",
        price: item.price,
        quantity: item.quantity || 0,
        sku: sku || item.sku
      };
    }
    
    // Si l'item vient de quoteData.items (format de l'erreur connue)
    if (item.product_name || item.product_image !== undefined) {
      return {
        name: item.product_name || item.name || 'Produit sans nom',
        image: item.product_image || item.image || "/assets/images/lalliard-lame-terrasse-focus_pin_du_nord_marron.png",
        price: item.product_price !== undefined ? item.product_price : (item.price || 0),
        quantity: item.quantity || 0,
        sku: sku || item.product_sku
      };
    }
    
    // Sinon, chercher dans selectedProducts
    const product = selectedProducts.find(p => 
      p.contentProductId === item.content_product || 
      p.contentProductId === item.contentProductId
    );
    
    if (product) {
      return {
        name: product.name,
        image: product.image,
        price: product.price,
        quantity: product.quantity,
        sku: product.sku || sku
      };
    }
    
    // Fallback vers les données de l'item API
    return {
      name: item.product_name || item.name || 'Produit sans nom',
      image: item.product_image || item.image || "/assets/images/lalliard-lame-terrasse-focus_pin_du_nord_marron.png",
      price: item.product_price !== undefined ? item.product_price : (item.price || 0),
      quantity: item.quantity || 0,
      sku: sku || item.product_sku
    };
  };

  // Utiliser selectedProducts si disponible, sinon utiliser quoteData.items
  const itemsToDisplay = selectedProducts && selectedProducts.length > 0 ? selectedProducts : (quoteData?.items || []);
  
  console.log('🔍 Items à afficher:', itemsToDisplay);
  console.log('🔍 Source des données:', selectedProducts && selectedProducts.length > 0 ? 'selectedProducts' : 'quoteData.items');

  // Mapping intelligent entre noms de produits et codes de formule terrasse
  // IMPORTANT: Vérifier les conditions les plus spécifiques en premier
  const mapProductToFormulaCode = (productName, sku, productType) => {
    if (!productName) return null;
    
    const nameLower = String(productName).toLowerCase();
    const skuLower = sku ? String(sku).toLowerCase() : '';
    const typeLower = productType ? String(productType).toLowerCase() : '';
    const searchText = `${nameLower} ${skuLower} ${typeLower}`;
    
    // Mapping par mots-clés - Conditions spécifiques en premier
    // 1. Cale d'isolation (doit être vérifié avant "lambourde" car peut contenir "sous lambourdes")
    if (searchText.includes('cale') && searchText.includes('isol')) return 'CALE_D_ISOLATION';
    // 2. Cale ventilation (doit être vérifié avant "lambourde")
    if (searchText.includes('cale') && searchText.includes('ventil')) return 'CALE_VENTILATION';
    // 3. Bande bitumineuse
    if (searchText.includes('bande') && (searchText.includes('bitum') || searchText.includes('bitume'))) return 'BANDE_BITUMINEUSE';
    // 4. Lames de terrasse (doit être vérifié avant "lambourde" car peut contenir "lambourde" dans la description)
    if (searchText.includes('lame') && (searchText.includes('terrasse') || searchText.includes('terrace'))) return 'LAMES_TERRASSE';
    // 5. Lambourde (vérifié après les cas spécifiques)
    if (searchText.includes('lambourde')) return 'LAMBOURDE';
    // 6. Autres produits
    if (searchText.includes('vis') || searchText.includes('visserie') || searchText.includes('visse')) return 'VISERIE';
    if (searchText.includes('plot') && (searchText.includes('dakota') || searchText.includes('plot'))) return 'PLOTS_DAKOTA';
    if (searchText.includes('géotextile') || searchText.includes('geotextile')) return 'GEOTEXTILE';
    if (searchText.includes('espaceur') || searchText.includes('kit serre') || searchText.includes('serre lame')) return 'ESPACEUR_&_KIT_SERRE_LAME';
    if (searchText.includes('foret') || searchText.includes('forêt') || searchText.includes('perçage') || searchText.includes('perçag')) return 'FORET_POUR_PRE_PERCAGE';
    if (searchText.includes('trait') && searchText.includes('découp')) return 'TRAIT_DECOUP';
    
    return null;
  };

  // Quantité recalculée via la formule terrasse (si surface dispo)
  const getCalculatedQuantity = (item) => {
    if (!terraceArea || terraceArea <= 0) {
      console.log('⚠️ Pas de surface terrasse, utilisation quantité originale:', item.quantity);
      return item.quantity || 1;
    }
    
    // Essayer d'abord avec le mapping intelligent
    const productName = item.name || item.product_name || '';
    const sku = item.sku || '';
    const productType = item.productType || item.product_type || '';
    
    let formulaCode = mapProductToFormulaCode(productName, sku, productType);
    console.log(`🔍 Mapping produit "${productName}":`, { sku, productType, formulaCode: formulaCode || 'non trouvé' });
    
    // Si pas trouvé, essayer avec les codes directs
    if (!formulaCode) {
      formulaCode = item.code || item.productType || item.product_type || item.sku || '';
      console.log(`🔍 Utilisation code direct:`, formulaCode);
    }
    
    if (!formulaCode) {
      console.warn('⚠️ Impossible de déterminer le code formule pour:', productName, '→ utilisation quantité originale:', item.quantity);
      return item.quantity || 1;
    }
    
    const calculatedQty = calculateTerraceQuantity(formulaCode, terraceArea);
    console.log(`✅ Calcul quantité: ${productName} (code: ${formulaCode}) → ${calculatedQty} (surface: ${terraceArea} m²)`);
    
    return calculatedQty;
  };
  
  // Construire les items pour le sync panier e-commerce [{ sku, qty }]
  const getSyncCartItems = () => {
    return itemsToDisplay
      .map((item) => {
        const pd = getProductDetails(item);
        const sku = pd.sku || item.sku || item.product_sku || '';
        const qty = getCalculatedQuantity({
          ...pd,
          productType: item.productType || item.product_type || pd.sku || pd.name,
          sku: item.sku || pd.sku,
          code: item.code || pd.code,
          quantity: pd.quantity
        });
        return { sku: String(sku).trim(), qty: Math.max(0, parseInt(qty, 10) || 0) };
      })
      .filter((i) => i.sku && i.qty > 0);
  };

  // Grouper les items par section
  const groupedItems = itemsToDisplay.reduce((acc, item) => {
    console.log('🔍 Item structure:', item);
    
    // Pour selectedProducts, utiliser les propriétés directes
    // Pour quoteData.items, utiliser les propriétés de l'API ou les propriétés formatées
    const sectionId = item.section || item.section_id;
    // Utiliser section_name si disponible (format de l'erreur connue), sinon résoudre le nom
    const sectionName = item.section_name || getSectionName(sectionId);
    console.log('🔍 Section name résolu:', sectionName, '(sectionId:', sectionId, ')');
    
    if (!acc[sectionName]) {
      acc[sectionName] = [];
    }
    acc[sectionName].push(item);
    return acc;
  }, {});

  const getSectionNameForQuotes = (sectionId) => {
    API.get(`/project/section/${sectionId}/`)
      .then(response => {
        console.log('🔍 Nom de la section récupéré depuis l\'API:', response.data.name);
        return response.data.name;
      })
      .catch(error => {
        console.error('Erreur lors de la récupération du nom de la section :', error);
        return `Section ${sectionId}`;
      });
  };

  return (
    <div className="terrace-page">
      <div className="page">
        <div className="container">
          <div className="row px-2 px-md-4 px-lg-5 g-2 g-md-0">
            <div className="col-12 col-md-5 px-2 px-md-0">
              <div className="image-terrasse">
                <img
                  src="/assets/images/Capture_terrace.jpg.png"
                  alt=""
                  className="w-100 h-100"
                />
              </div>
            </div>
            <div className="col-12 col-md-7 px-2 px-md-0">
              {/* Affichage des données du devis si disponibles */}
              {quoteData && quoteData.items && quoteData.items.length > 0 ? (
                <div>
                  {Object.entries(groupedItems).map(([sectionName, items]) => (
                    <div key={sectionName}>
                      <div className="kit-band py-2 ps-3 ps-md-5">
                        <span className="text-2">
                          {sectionName}
                          {getSectionNameForQuotes(sectionName)}
                        </span>
                      </div>
                      {items.map((item, index) => {
                        const productDetails = getProductDetails(item);
                        const computedQty = getCalculatedQuantity({
                          ...productDetails,
                          productType: item.productType || item.product_type || productDetails.sku || productDetails.name,
                          sku: item.sku || productDetails.sku,
                          code: item.code || productDetails.code,
                          quantity: productDetails.quantity
                        });
                        const effectiveQty = computedQty ?? productDetails.quantity;
                        const lineTotal = (productDetails.price || 0) * (effectiveQty || 0);

                        return (
                          <div key={index} className="d-flex flex-column flex-md-row pe-2 py-3 py-md-4 content align-items-start">
                            <div className="ps-0 ps-md-4">
                              <div className="card">
                                <img
                                  src={productDetails.image}
                                  alt={productDetails.name}
                                  className="w-100 h-100"
                                  onError={(e) => {
                                    e.target.src = "/assets/images/lalliard-lame-terrasse-focus_pin_du_nord_marron.png";
                                  }}
                                />
                              </div>
                            </div>
                            <div className="ps-0 ps-md-3 flex-grow-1">
                              <div className="mb-2 mb-md-3">
                                <span className="text-2">
                                  {productDetails.name}
                                </span>
                              </div>
                              <span className="text-4">
                                Prix unitaire: {productDetails.price ? productDetails.price.toFixed(2) : 'N/A'} €
                                <br />
                                Quantité: {effectiveQty || 'N/A'}
                                <br />
                                Prix total: {productDetails.price && effectiveQty ? lineTotal.toFixed(2) : 'N/A'} €
                              </span>
                            </div>
                            <div className="ms-0 ms-md-3 mt-2 mt-md-0">
                              <span style={{ color: "#B39C81", fontWeight: "bold" }}>
                                {productDetails.price && effectiveQty ? lineTotal.toFixed(2) : 'N/A'} €
                              </span>
                              <br />
                              <span style={{ color: "#B39C81", fontWeight: "bold" }}>
                                {effectiveQty || 'N/A'} unité(s)
                              </span>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  ))}
                  
                  {/* Total du devis */}
                  <div className="kit-band d-flex flex-wrap py-2 ps-3 ps-md-5 pe-3 pe-md-4 justify-content-between align-items-center gap-2">
                    <div>
                      <span className="text-2">TOTAL DE VOTRE DEVIS : </span>
                    </div>
                    <div>
                      <span className="text-3-price" style={{ color: "black" }}>
                        {(() => {
                          // Calculer le total à partir des produits affichés avec les quantités calculées
                          const calculatedTotal = itemsToDisplay.reduce((total, item) => {
                            const pd = getProductDetails(item);
                            const computedQty = getCalculatedQuantity({
                              ...pd,
                              productType: item.productType || item.product_type || pd.sku || pd.name,
                              sku: item.sku || pd.sku,
                              code: item.code || pd.code,
                              quantity: pd.quantity
                            });
                            const effectiveQty = computedQty ?? pd.quantity;
                            return total + ((pd.price || 0) * (effectiveQty || 0));
                          }, 0);
                          
                          // Utiliser le total calculé ou celui de quoteData (peut être 0)
                          const totalToShow = calculatedTotal > 0 ? calculatedTotal : (quoteData?.total_cost !== undefined ? quoteData.total_cost : 0);
                          return totalToShow.toFixed(2);
                        })()} € TTC
                      </span>
                    </div>
                  </div>
                  
                  {/* Message de succès */}
                  <div className="ps-5 pe-4 py-4 content">
                    <span className="text-4">
                      Votre devis a été soumis avec succès ! Vous recevrez un email avec les détails complets.
                    </span>
                  </div>
                  <div className="ps-5 pe-4 py-4 content">
                    <span className="text-4">
                      Infobulle «&nbsp; vous avez des questions avant de finaliser votre
                      commande, sauvegardez votre devis et un conseiller Rullier Bois vous
                      rappellera pour répondre à vos questions.
                    </span>
                  </div>
                  <div className="kit-band-devis py-2 px-3 px-md-5">
                    <img src="/assets/images/Group 21.png" alt="" />
                    <span className="text-3 ms-2">Télécharger mon devis</span>
                  </div>
                  <div className="d-flex ps-3 pe-3 ps-md-0 pe-md-0">
                    <div className="mt-3 w-100">
                      <div className="btn btn-secondary mb-2 mb-md-3 rounded-0 btn-block-sm">
                        <span className="">Accéder aux conseils de pose</span>
                      </div>
                      <div className="d-flex flex-column flex-sm-row flex-wrap align-items-stretch align-items-sm-center gap-2 btn-actions-wrap">
                        <div className="systeme-fixation">
                          <span className="text-2"><Link to='#'><FaLongArrowAltLeft /> Modifier mon devis</Link></span>
                        </div>
                        <button
                          type="button"
                          className="btn btn-secondary box-green rounded-0 flex-grow-1 flex-sm-grow-0"
                          onClick={async () => {
                            const syncItems = getSyncCartItems();
                            if (!syncItems.length) {
                              setSyncStatus('error');
                              setSyncMessage('Aucun produit avec SKU valide à envoyer au panier.');
                              setSyncErrors([]);
                              return;
                            }
                            setSyncStatus('loading');
                            setSyncMessage(null);
                            setSyncErrors([]);
                            try {
                              const result = await syncQuoteToEcommerceCart(syncItems);
                              if (result.success) {
                                setSyncStatus('success');
                                setSyncMessage(
                                  result.items_added !== undefined
                                    ? `${result.items_added} produit(s) ajouté(s) au panier.`
                                    : 'Devis envoyé au panier.'
                                );
                                if (result.redirect_url) {
                                  const fullUrl = result.redirect_url.startsWith('http')
                                    ? result.redirect_url
                                    : `https://app.rullier.ova-consulting.fr${result.redirect_url.startsWith('/') ? '' : '/'}${result.redirect_url}`;
                                  window.open(fullUrl, '_blank');
                                }
                              } else {
                                setSyncStatus('error');
                                setSyncMessage("Erreur lors de l'envoi au panier.");
                                setSyncErrors(result.errors || []);
                              }
                            } catch (err) {
                              setSyncStatus('error');
                              setSyncMessage(err.response?.data?.message || err.message || 'Impossible de contacter le site e-commerce.');
                              setSyncErrors(
                                err.response?.data?.errors
                                  ? Array.isArray(err.response.data.errors)
                                    ? err.response.data.errors
                                    : [err.response.data.errors]
                                  : []
                              );
                            }
                          }}
                          disabled={syncStatus === 'loading'}
                        >
                          <span className="text-2"> Je commande ma terrasse  <FaLongArrowAltRight /></span>
                        </button>
                      </div>
                      {syncStatus === 'success' && syncMessage && (
                        <div className="alert alert-success small py-2 mb-2 mt-2">
                          {syncMessage} Une fenêtre s'est ouverte vers le panier.
                        </div>
                      )}
                      {syncStatus === 'error' && (
                        <div className="alert alert-danger small py-2 mb-2 mt-2">
                          {syncMessage}
                          {syncErrors.length > 0 && (
                            <ul className="mb-0 mt-1 ps-3">
                              {syncErrors.map((e, i) => (
                                <li key={i}>{e}</li>
                              ))}
                            </ul>
                          )}
                        </div>
                      )}
                      <div className="mt-4 w-100 mb-4">
                        <Link to="/" className="btn btn-outline-secondary rounded-0 btn-block-sm d-inline-block text-center">
                          <span className="text-2">Retour à l'accueil</span>
                        </Link>
                      </div>
                    </div>
                  </div>
                  
                  {/* Calculs détaillés (formule terrasse) - commenté
                  <div className="mt-4 px-2 px-md-4">
                    <h5 className="mb-3">Calculs détaillés (formule terrasse)</h5>
                    <div className="table-responsive">
                      <table className="table table-bordered align-middle">
                        <thead className="table-light">
                          <tr>
                            <th style={{ width: '30%' }}>Produit</th>
                            <th style={{ width: '40%' }}>Calcul</th>
                            <th style={{ width: '30%' }}>Quantité</th>
                          </tr>
                        </thead>
                        <tbody>
                          {terraceFormulaRows.map(row => {
                            // Calcul détaillé pour les lambourdes
                            if (row.code === 'LAMBOURDE' && terraceArea > 0) {
                              const longueurLambourde = 3; // ML
                              const mlTotal = terraceArea * 2;
                              const nombreLambourdesAvantArrondi = mlTotal / longueurLambourde;
                              const nombreLambourdes = Math.ceil(nombreLambourdesAvantArrondi);
                              
                              return (
                                <tr key={row.code}>
                                  <td>{row.label}</td>
                                  <td>
                                    <div>
                                      <div><strong>Étape 1 :</strong> ML total = {terraceArea} × 2 = {mlTotal.toFixed(2)} ML</div>
                                      <div><strong>Étape 2 :</strong> Nombre de lambourdes = {mlTotal.toFixed(2)} ÷ {longueurLambourde} = {nombreLambourdesAvantArrondi.toFixed(2)}</div>
                                      <div><strong>Étape 3 :</strong> Arrondi au-dessus → <strong>{nombreLambourdes} lambourdes</strong></div>
                                    </div>
                                  </td>
                                  <td>
                                    <strong>{nombreLambourdes} {row.unit}</strong>
                                  </td>
                                </tr>
                              );
                            }
                            
                            // Affichage standard pour les autres produits
                            return (
                              <tr key={row.code}>
                                <td>{row.label}</td>
                                <td>{row.formula}</td>
                                <td>
                                  {terraceArea
                                    ? `${row.quantity} ${row.unit}`
                                    : 'Surface non renseignée'}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                    <p className="text-muted small mb-0">
                      NB : le taux de chute (+7%) ne s’applique qu’aux lames de terrasse.
                    </p>
                  </div> */}

                  {/* Produits sélectionnés et soumis - commenté */}
                  {/* <div className="mt-4 px-2 px-md-4">
                    <h5 className="mb-3">Produits sélectionnés et soumis</h5>
                    <div className="table-responsive">
                      <table className="table table-bordered align-middle">
                        <thead className="table-light">
                          <tr>
                            <th style={{ width: '40%' }}>Produit</th>
                            <th style={{ width: '15%' }}>Prix unitaire (€)</th>
                            <th style={{ width: '15%' }}>Quantité</th>
                            <th style={{ width: '15%' }}>Total (€)</th>
                          </tr>
                        </thead>
                        <tbody>
                          {itemsToDisplay.map((item, idx) => {
                            const pd = getProductDetails(item);
                            const computedQty = getCalculatedQuantity({
                              ...pd,
                              productType: item.productType || item.product_type || pd.sku || pd.name,
                              sku: item.sku || pd.sku,
                              code: item.code || pd.code,
                              quantity: pd.quantity
                            });
                            const lineTotal = (pd.price || 0) * (computedQty || 0);
                            return (
                              <tr key={`summary-${idx}`}>
                                <td>{pd.name}</td>
                                <td>{pd.price ? pd.price.toFixed(2) : 'N/A'}</td>
                                <td>{computedQty ?? 'N/A'}</td>
                                <td>{pd.price && computedQty ? lineTotal.toFixed(2) : 'N/A'}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                        <tfoot>
                          <tr>
                            <th colSpan={3} className="text-end">Total</th>
                            <th>
                              {(() => {
                                const total = itemsToDisplay.reduce((sum, item) => {
                                  const pd = getProductDetails(item);
                                  const computedQty = getCalculatedQuantity({
                                    ...pd,
                                    productType: item.productType || item.product_type || pd.sku || pd.name,
                                    sku: item.sku || pd.sku,
                                    code: item.code || pd.code,
                                    quantity: pd.quantity
                                  });
                                  return sum + ((pd.price || 0) * (computedQty || 0));
                                }, 0);
                                return total.toFixed(2);
                              })()} €
                            </th>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div> */}
                </div>
              ) : (
                // Affichage par défaut si pas de données de devis
                <div>
                  <div className="kit-band py-2 ps-5">
                    <span className="text-2">BOIS DE NOUVELLE AQUITAINE</span>
                  </div>
                  
                  <div className="d-flex pe-2 py-4 content">
                    <div className="ps-4">
                      <div className="card">
                        <img
                          src="/assets/images/lalliard-lame-terrasse-focus_pin_du_nord_marron.png"
                          alt=""
                          className="w-100 h-100"
                        />
                      </div>
                    </div>
                    <div className="ps-3">
                      <div className="mb-3">
                        <span className="text-2">
                          LAME DE TERRASSE LISSE PIN CLASSE 4 CHOIX US MARRON 26X145
                        </span>
                      </div>
                      <span className="text-4">
                        Lame Terrasse - Pin Sylvestre VERT
                        <br />
                        Traité autoclave classe 4<br />
                        Section : Ep.27 x l.145 mm
                        <br />
                        Longueur : comprise entre 2,40 m et 6,00 m<br />
                        Profil : lisse ou strié
                        <br />
                        Prix détaillés :<br />
                        Qualité AB - Prix Promotionnel : 19.90€ ht/m² au lieu de 23.75 €
                        ht/m²
                        <br />
                        Qualité US (petits noeuds) - Prix : 29.75€ ht/m²
                        <br />
                        Existe aussi en BRUN
                        <br />
                      </span>
                    </div>
                    <div className="ms-3">
                      <span style={{ color: "#B39C81", fontWeight: "bold" }}>
                        20,39 € / m2
                      </span>
                      <span style={{ color: "#B39C81", fontWeight: "bold" }}>100 m2</span>
                    </div>
                  </div>
                  <div className="kit-band py-2 ps-5">
                    <span className="text-2">STRUCTURE ET FIXATIONS</span>
                  </div>
                  
                  <div className="content">
                    <div className="d-flex pe-2 pt-4">
                      <div className="ima ps-4">
                        <div className="card">
                          <img
                            src="/assets/images/Screenshot 2023-12-16 at 18.14.52.png"
                            alt=""
                            className="w-100 h-100"
                          />
                        </div>
                      </div>
                      <div className="ps-3">
                        <div className="mb-3">
                          <span className="text-2">
                            Lambourde Pin Sylvestre - Traité classe 4
                          </span>
                        </div>
                        <span className="text-4">
                          Lambourde Pin Sylvestre
                          <br />
                          Sections : 46 x 72 mm
                          <br />
                          Traité autoclave classe 4<br />
                          Longueurs entre 2.70m et 6.00m (selon stock)
                          <br />
                        </span>
                      </div>
                      <div className="ms-5">
                        <span className="text-4" style={{ color: "black" }}>
                          375 Mètre(s)
                        </span>
                      </div>
                    </div>
                    <div className="container" style={{ color: "#D4D4D4" }}>
                      <hr />
                    </div>
                    <div className="d-flex pe-2 pt-4">
                      <div className="ima ps-4">
                        <div className="card">
                          <img
                            src="/assets/images/Screenshot 2023-12-16 at 18.19.17 Copy.png"
                            alt=""
                            className="w-100 h-100"
                          />
                        </div>
                      </div>
                      <div className="ps-3">
                        <div className="mb-3">
                          <span className="text-2">
                            Vis Terrasse Acton inox A2 5x60 BTE200
                          </span>
                        </div>
                        <span className="text-4">
                          Vis Acton inox A2 - 5x60
                          <br />
                          Spéciale terrasse bois
                        </span>
                      </div>
                      <div className="ms-5">
                        <span className="text-4" style={{ color: "black" }}>
                          27 Unité(s)
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="kit-band py-2 ps-5">
                    <span className="text-2">ACCESSOIRES</span>
                  </div>
                  
                  <div className="content">
                    <div className="d-flex pe-2 py-4">
                      <div className="ima ps-4">
                        <div className="card">
                          <img
                            src="/assets/images/Screenshot 2023-12-16 at 18.51.48 (1).png"
                            alt=""
                            className="w-100 h-100"
                          />
                        </div>
                      </div>
                      <div className="ps-3">
                        <div className="mb-3">
                          <span className="text-2">
                            Bande Bitumeuse pour Lambourdes 20 ml - Növlek
                          </span>
                        </div>
                        <span className="text-4">
                          Bande de protection bitumineuse pour lambourdes - 20ML
                          <br />
                          Marque : NOVLEK
                          <br />
                          Conditionnement : Rouleau de 5m²
                          <br />
                          Matériau : Bitume élastomère Polyester
                          <br />
                          Couleur : Gris
                          <br />
                          Dimension : 80mm x 20m
                          <br />
                          Épaisseur : 2.4mm
                          <br />
                          EAN : 5425 03355 205 3<br />
                          Ref : BITU-08020-01
                          <br />
                        </span>
                      </div>
                      <div className="ms-5">
                        <span className="text-4" style={{ color: "black" }}>
                          19 Unité(s)
                        </span>
                      </div>
                    </div>
                    <div className="container" style={{ color: "#D4D4D4" }}>
                      <hr />
                    </div>
                    <div className="d-flex pe-2 py-4">
                      <div className="ima ps-4">
                        <div className="card">
                          <img
                            src="/assets/images/Screenshot 2023-12-16 at 18.52.27 Copy.png"
                            alt=""
                            className="w-100 h-100"
                          />
                        </div>
                      </div>
                      <div className="ps-3">
                        <div className="mb-3">
                          <span className="text-2">
                            Plot Réglable Terrasse Lambourde - 50/80 mm - Jouplast
                          </span>
                        </div>
                        <span className="text-4">
                          Plots réglables en hauteur pour lambourdes
                          <br />
                          50/80 mm
                          <br />
                          Conditionnement 60 pièces
                          <br />
                          Marque : Jouplast Essentiel
                          <br />
                          Existe aussi en : 20/30 - 40/60 - 80/140 - 140/230 mm
                          <br />
                        </span>
                      </div>
                      <div className="ms-5">
                        <span className="text-4" style={{ color: "black" }}>
                          10 Unité(s)
                        </span>
                      </div>
                    </div>
                    <div className="container" style={{ color: "#D4D4D4" }}>
                      <hr />
                    </div>
                    <div className="d-flex pe-2 py-4">
                      <div className="ima ps-4">
                        <div className="card">
                          <img
                            src="/assets/images/Screenshot 2023-12-16 at 19.42.41 Copy.png"
                            alt=""
                            className="w-100 h-100"
                          />
                        </div>
                      </div>
                      <div className="ps-3">
                        <div className="mb-3">
                          <span className="text-2">Espaceurs Lame - Spax</span>
                        </div>
                        <span className="text-4">
                          Espaceurs de la lame
                          <br />
                          Marque : SPAX
                          <br />
                          - 4/5/6/7 mm
                          <br />
                          Conditionnement : Boite de 12 pcs
                          <br />
                        </span>
                      </div>
                      <div className="ms-5">
                        <span className="text-4" style={{ color: "black" }}>
                          1 Unité(s)
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="kit-band d-flex flex-wrap py-2 ps-3 ps-md-5 pe-3 pe-md-4 justify-content-between align-items-center gap-2">
                    <div>
                      <span className="text-2">TOTAL DE VOTRE DEVIS : </span>
                    </div>
                    <div>
                      <span className="text-3-price" style={{ color: "black" }}>
                        7 929,36 € TTC{" "}
                      </span>
                    </div>
                  </div>
                  
                  <div className="ps-3 ps-md-5 pe-3 pe-md-4 py-4 content">
                    <span className="text-4">
                      Infobulle «&nbsp; vous avez des questions avant de finaliser votre
                      commande, sauvegardez votre devis et un conseiller Rullier Bois vous
                      rappellera pour répondre à vos questions.
                    </span>
                  </div>
                  <div className="kit-band-devis py-2 px-3 px-md-5">
                    <img src="/assets/images/Group 21.png" alt="" />
                    <span className="text-3 ms-2">Télécharger mon devis</span>
                  </div>
                  <div className="d-flex ps-3 pe-3 ps-md-0 pe-md-0">
                    <div className="mt-3 w-100">
                      <div className="btn btn-secondary mb-2 mb-md-3 rounded-0 btn-block-sm">
                        <span className="">Accéder aux conseils de pose</span>
                      </div>
                      <div className="d-flex flex-column flex-sm-row flex-wrap align-items-stretch align-items-sm-center gap-2 btn-actions-wrap">
                        <div className="systeme-fixation">
                          <span className="text-2"><Link to='#'><FaLongArrowAltLeft /> Modifier mon devis</Link></span>
                        </div>
                        <div className="btn btn-secondary box-green mb-0 rounded-0 flex-grow-1 flex-sm-grow-0">
                          <span className="text-2"><Link to='#' className="text-decoration-none text-reset"> Je commande ma terrasse  <FaLongArrowAltRight /></Link></span>
                        </div>
                      </div>
                      <div className="mt-2">
                        <Link to="/" className="btn btn-outline-secondary rounded-0 btn-block-sm d-inline-block text-center">
                          <span className="text-2">Retour à l'accueil</span>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TerraceProduct